/** 2ᵉ barre Paramètres — `ready` = écran branché. */
export type SettingsNavId =
  | "company"
  | "formats"
  | "taxes"
  | "products"
  | "model"
  | "numbering"
  | "email"
  | "portal"
  | "workflow"
  | "payments"
  | "controls"
  | "exchange";

export type SettingsNavEntry = {
  id: SettingsNavId;
  label: string;
  ready: boolean;
};

export const SETTINGS_NAV: SettingsNavEntry[] = [
  { id: "company", label: "Information sur l’entreprise", ready: true },
  { id: "formats", label: "Formats", ready: true },
  { id: "taxes", label: "Taxes", ready: true },
  { id: "products", label: "Produits", ready: true },
  { id: "model", label: "Modèles", ready: true },
  { id: "numbering", label: "Numérotation", ready: true },
  { id: "email", label: "E-mails", ready: true },
  { id: "portal", label: "Portail", ready: true },
  { id: "workflow", label: "Flux de travail", ready: true },
  { id: "payments", label: "Paiements", ready: true },
  { id: "exchange", label: "Import / Export", ready: true },
  { id: "controls", label: "Contrôles", ready: true },
];
